import LuxIdCard from './LuxIdCard';

export default LuxIdCard;
